import { MeScreenNavigationProps } from "./types"
import React from "react"
import Me from "./me-screen"
import { PageRoot } from "~screens/page-root"


const MeScreen: React.FC<MeScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <Me />
    </PageRoot>
  )
}

export default MeScreen
